import "./pdfView.css";
import Button from "../Button/Button";
import backIcon from "../images/Back.png";
import cancelIcon from "../images/Cancel.png";
import downloadIcon from "../images/DownloadFile.png";
import PDFLoader from "../../../../Editor/PdfViewer/PDFLoader";
import { useGlobalContext } from "../../../../Context/Context";
import { useEffect, useState } from "react";
import axios from "axios";
import { compareAsc, format } from "date-fns";
import Pdf from "../../../../Editor/PdfViewer/Pdf";
import { PDFDownloadLink, pdf } from "@react-pdf/renderer";

const PdfView = ({
  setDetailedChecked,
  setSelectedFilterFile,
  selectedFilterFile,
  setFilteringChecked,
  setAddingDocument,
  setAddingChecked,
  showingItems,
  setShowingItems,
  location,
  selectedCompany,
  filterState,
  location_input,
}) => {
  console.log(showingItems);
  const { loggedUser, baseUrl, apiKey } = useGlobalContext();
  const { account } = useGlobalContext();
  const [numberOfCopy, setNumberOfCopy] = useState([]);
  const [categoriesItem, setCategoriesItem] = useState([]);
  const [currentItem, setCurrentItem] = useState(1);
  const [fileSize, setFileSize] = useState(0);

  const handleFullBack = () => {
    setDetailedChecked(false);
    setFilteringChecked(0);
    setAddingChecked(false);
  };

  const pdfLink = (
    <Pdf
      account={{
        ...selectedCompany,
        name: selectedCompany.company_name,
      }}
      location={location}
      loggedUser={loggedUser}
      numberOfCopy={numberOfCopy}
      categoriesItem={categoriesItem}
      itemList={showingItems}
      imagesActive={true}
      documentsActive={true}
      linksActive={true}
      commentsActive={true}
    />
  );

  const handleReturnAdd = async () => {
    const pdfBlob = await pdf(pdfLink).toBlob();
    const url = URL.createObjectURL(pdfBlob);
    const fileName = `REPORT-${format(filterState.startDate, "dd.MM.yyyy")}${
      filterState.endDate && `-${format(filterState.endDate, "dd.MM.yyyy")}`
    }.pdf`;

    const reader = new FileReader();

    // Kada je čitanje završeno, dobijamo data URL
    reader.onloadend = () => {
      const base64data = reader.result; // Ovo je data URL
      console.log(base64data); // Ispisuje data URL u konzolu
      console.log(pdfBlob.type.split("/")[1]);
      const newDocument = {
        uploader: loggedUser.name,
        type: pdfBlob.type.split("/")[1],
        size: pdfBlob.size,
        date: new Date(),
        title: fileName,
        text: "",
        data: base64data,
        fromEditor: false, // bilo u editoru
        intoEditor: false, // trenutno u editoru
      };
      setAddingDocument(newDocument);
      setDetailedChecked(false);
      setFilteringChecked(0);
    };

    // Čitaj Blob kao Data URL
    reader.readAsDataURL(pdfBlob);

    /*const link = document.createElement("a");
    link.href = url;
    link.download = url;
    link.click();*/
  };

  const getSize = async () => {
    const pdfBlob = await pdf(pdfLink).toBlob();
    setFileSize(pdfBlob.size);
  };

  const convertBytes = (bytes) => {
    let returnValue,
      i = 1;
    while (bytes > Math.pow(1024, i)) i++;
    if (i === 1)
      returnValue = `${Math.round(bytes / Math.pow(1024, i - 1), 2)}B`;
    else if (i === 2)
      returnValue = `${Math.round(bytes / Math.pow(1024, i - 1), 2)}KB`;
    else if (i === 3)
      returnValue = `${Math.round(bytes / Math.pow(1024, i - 1), 2)}MB`;
    else returnValue = `${Math.round(bytes / Math.pow(1024, i - 1), 2)}GB`;
    return returnValue;
  };

  useEffect(() => {
    const handleGetNumberOfCopy = async () => {
      try {
        const { data } = await axios.post(
          `${baseUrl}/reports_counter/getNumberOfCopy.php`,
          {
            location_id: parseInt(location.location_id),
            location_input,
            startDate:
              showingItems.length !== 0 &&
              format(showingItems[0].timeCreated, "yyyy-MM-dd"),
            endDate:
              showingItems.length !== 0 &&
              (compareAsc(
                new Date(
                  new Date(showingItems[0].timeCreated).setHours(0, 0, 0, 0)
                ),
                new Date(
                  new Date(
                    showingItems[showingItems.length - 1].timeCreated
                  ).setHours(0, 0, 0, 0)
                )
              ) !== 0
                ? format(
                    showingItems[showingItems.length - 1].timeCreated,
                    "yyyy-MM-dd"
                  )
                : ""),
            user_id: loggedUser.id,
            api_key: apiKey,
          }
        );
        if (data.status === 200) {
          setNumberOfCopy(data.counter);
        } else {
          setNumberOfCopy(1);
        }
      } catch (error) {
        console.log("Error fetching number of copies", error);
      }
    };
    handleGetNumberOfCopy();
    const handleSetCategories = async () => {
      try {
        const { data } = await axios.post(
          `${baseUrl}/categories/getAllCategoriesByLocationId.php`,
          {
            location_id: parseInt(location.location_id),
            location_input,
            api_key: apiKey,
            user_id: loggedUser.id,
            item_id: undefined,
          }
        );
        if (data.status === 200) {
          let findCategories = [];
          showingItems.forEach((item) => {
            if (item.categories !== undefined && item.categories.length !== 0)
              findCategories.push(...item.categories);
          });
          console.log(findCategories);
          findCategories = Array.from(new Set(findCategories));
          const categories = data.categories.filter((category) =>
            findCategories.includes(category.id)
          );
          console.log(categories);
          setCategoriesItem(categories);
        }
      } catch (error) {
        console.log("Error fetching categories", error);
      }
    };
    handleSetCategories();
    getSize();
  }, []);

  return (
    <div className="folder-app-main detail">
      <div className="folder-app-header">
        <div className="folder-app-header-part column">
          <span className="pdf-view-text">
            {`REPORT: ${format(filterState.startDate, "dd.MM.yyyy")}${
              filterState.endDate &&
              ` - ${format(filterState.endDate, "dd.MM.yyyy")}`
            }`}
          </span>
          <div className="pdf-view-info">
            <span>PDF</span>
            <span className="middle">{`${currentItem}/${showingItems.length}`}</span>
            <span>{convertBytes(fileSize)}</span>
          </div>
        </div>
        <div className="folder-app-header-part detail">
          <div className="add-button" onClick={() => setDetailedChecked(false)}>
            <Button image={backIcon} />
          </div>
          <div className="add-button end" onClick={handleFullBack}>
            <Button image={cancelIcon} />
          </div>
          <div className="add-button " style={{ display: "none" }}></div>
          <div className="add-button" onClick={handleReturnAdd}>
            <Button image={downloadIcon} />
          </div>
        </div>
      </div>
      <hr className="folder-app-line"></hr>
      <div className="folder-app-folders-wrapper">
        <div className="pdf-viewer">
          <PDFLoader
            account={{ ...selectedCompany, name: selectedCompany.company_name }}
            location={location}
            loggedUser={loggedUser}
            numberOfCopy={numberOfCopy}
            categoriesItem={categoriesItem}
            itemList={showingItems}
            imagesActive={false}
            documentsActive={false}
            linksActive={false}
            commentsActive={false}
            setCurrentItem={setCurrentItem}
          ></PDFLoader>
        </div>
      </div>
    </div>
  );
};

export default PdfView;
